import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import PrivacyPolicy from "../components/privacyDocument";
import Canonical from "../components/canonical";

export function Privacy() {
  return (
    <React.Fragment>
      <Canonical />
      <Navbar linkName="Home" />
      <div className=" bg-[#01184D] text-white w-full text-center flex flex-col items-center justify-center h-[300px]">
        <div className="mb-2 mt-12">
          <h1 className="uppercase md:text-4xl text-xl sm:text-2xl pb-8">
            Privacy Policy
          </h1>
        </div>
      </div>
      <PrivacyPolicy />
      <Footer year={new Date().getFullYear()} />
    </React.Fragment>
  );
}
